import React from "react";

export const NominatorLoadingState = () =>
    <div className="flex flex-col justify-center items-center w-full">
        <p>Nominators are beeing loaded</p>
    </div>

